module.exports = __webpack_public_path__ + "img/jam.c916d6c1.png";